var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVideo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_28_Video",
    "data-name": "28_Video",
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 63.992,
    viewBox: "0 0 64 63.992",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_68",
    stroke: "current",
    "data-name": "Path 68",
    d: "M62.63,12.64A13.408,13.408,0,0,0,51.25,1.352a138.109,138.109,0,0,0-38.6.014A13.405,13.405,0,0,0,1.357,12.746,137.344,137.344,0,0,0,1.37,51.353,13.408,13.408,0,0,0,12.75,62.641,137.867,137.867,0,0,0,32,64a137.913,137.913,0,0,0,19.354-1.37,13.405,13.405,0,0,0,11.289-11.38A137.6,137.6,0,0,0,64,32a137.693,137.693,0,0,0-1.366-19.332ZM57.362,50.5h0A8.044,8.044,0,0,1,50.6,57.345a132.473,132.473,0,0,1-37.107.014A8.045,8.045,0,0,1,6.651,50.6a131.93,131.93,0,0,1-.013-37.108A8.044,8.044,0,0,1,13.4,6.648,131.991,131.991,0,0,1,50.5,6.633a8.046,8.046,0,0,1,6.846,6.759A132.2,132.2,0,0,1,58.667,32a132.5,132.5,0,0,1-1.3,18.5Z",
    transform: "translate(0 -0.004)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_69",
    stroke: "current",
    "data-name": "Path 69",
    d: "M40.424,36.473l-11.9-4.759a6.667,6.667,0,0,0-9.141,6.19v9.518a6.665,6.665,0,0,0,9.141,6.19l11.9-4.76a6.667,6.667,0,0,0,0-12.379ZM38.445,43.9l-11.9,4.759a1.332,1.332,0,0,1-1.828-1.237V37.9a1.332,1.332,0,0,1,1.828-1.237l11.9,4.758a1.334,1.334,0,0,1,0,2.475Z",
    transform: "translate(0 -0.004)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_70",
    stroke: "current",
    "data-name": "Path 70",
    d: "M53.333,21.33H10.667a2.667,2.667,0,1,0,0,5.333H53.333a2.667,2.667,0,1,0,0-5.333Z",
    transform: "translate(0 -0.004)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_71",
    stroke: "current",
    "data-name": "Path 71",
    d: "M16,18.663a2.658,2.658,0,0,0,1.885-.781l5.333-5.333a2.666,2.666,0,1,0-3.771-3.771l-5.333,5.333A2.667,2.667,0,0,0,16,18.663Z",
    transform: "translate(0 -0.004)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_72",
    stroke: "current",
    "data-name": "Path 72",
    d: "M29.333,18.663a2.658,2.658,0,0,0,1.885-.781l5.333-5.333a2.666,2.666,0,1,0-3.771-3.771l-5.333,5.333a2.667,2.667,0,0,0,1.885,4.552Z",
    transform: "translate(0 -0.004)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_73",
    stroke: "current",
    "data-name": "Path 73",
    d: "M42.667,18.663a2.658,2.658,0,0,0,1.885-.781l5.333-5.333a2.666,2.666,0,1,0-3.771-3.771l-5.333,5.333a2.667,2.667,0,0,0,1.886,4.552Z",
    transform: "translate(0 -0.004)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideo);
export default __webpack_public_path__ + "static/media/video.cdb37d3f.svg";
export { ForwardRef as ReactComponent };